import { useTranslation } from 'react-i18next';
import { Button } from 'components';
import { usePatientSync } from 'providers/PatientSyncProvider';
import { formatPatientName } from 'utils/visitReasonDisplay';
import { BannerBox, BannerIcon, BannerMessage, BannerText } from './PatientMismatchBanner.styles';

export function PatientMismatchBanner() {
  const { t } = useTranslation();
  const { syncState, pendingPatient, switchToPendingPatient } = usePatientSync();

  if (syncState !== 'out-of-sync' || !pendingPatient) return null;

  return (
    <BannerBox>
      <BannerMessage>
        <BannerIcon />
        <BannerText data-ph-no-autocapture>
          {pendingPatient.fullName
            ? t('patientSync.mismatchBanner.textWithName', {
                name: formatPatientName(pendingPatient.fullName),
              })
            : t('patientSync.mismatchBanner.text')}
        </BannerText>
      </BannerMessage>
      <Button type="button" size="xs" className="shrink-0 py-0" onClick={switchToPendingPatient}>
        {t('patientSync.mismatchBanner.switchToPatient')}
      </Button>
    </BannerBox>
  );
}
